var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollLeftRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4903 5.12931C24.2864 3.07357 19.4715 2.09676 14.4523 2.53391C9.73403 2.94486 5.30133 4.5976 1.66797 7.07391",
    stroke: "#575757",
    strokeWidth: 2.47516,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8604 1.72107L1.66797 7.07398L7.1977 8.23592",
    stroke: "#575757",
    strokeWidth: 2.47516,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9389 9.18803C27.4386 7.19936 26.2315 5.18214 24.2428 4.68244C22.2542 4.18275 20.2369 5.3898 19.7372 7.37848L19.7372 7.37849L17.506 16.2585L17.0229 18.1809L15.8227 17.8793C13.834 17.3796 11.8168 18.5867 11.3171 20.5754L10.4439 24.0505C9.96448 25.9584 10.1487 27.9726 10.9662 29.7619L12.0755 29.2551L10.9662 29.7619L13.1769 34.6003L15.4282 33.5717L13.2175 28.7333C12.6336 27.4552 12.502 26.0165 12.8444 24.6537L13.7176 21.1785C13.8842 20.5156 14.5566 20.1133 15.2195 20.2799L15.4939 19.1876L15.2195 20.2799L16.4147 20.5802L15.8119 22.9794L18.2124 23.5826L18.8153 21.1834L18.8203 21.1846L19.1219 19.9844L19.9065 16.8616L22.1378 7.98166L22.1378 7.98166C22.3044 7.31877 22.9768 6.91642 23.6396 7.08298C24.3025 7.24955 24.7049 7.92196 24.5383 8.58484L25.69 8.87423L24.5383 8.58485L22.4272 16.9867L22.1755 17.9885L23.116 18.4153L32.4257 22.6402C33.6466 23.1943 34.2044 24.6198 33.6837 25.8553L30.3352 33.8013L32.6161 34.7625L35.9646 26.8165C37.006 24.3454 35.8904 21.4944 33.4486 20.3863L32.9371 21.5132L33.4486 20.3863L25.0794 16.5882L26.9389 9.18803Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollLeftRight);
export default __webpack_public_path__ + "static/media/scrollLeftRight.7bf3a7e5aab7b1a2d8f8fb7da4e5d8ad.svg";
export { ForwardRef as ReactComponent };